import React, { useContext } from 'react';
import { LocalizationContext } from '../../context/LangChange';
const translations = {
    en: require('../../Translate/en.json'),
    ar: require('../../Translate/ar.json'),
};

const ServicesSlider = ({ data }) => {
    const { isLang } = useContext(LocalizationContext);
    const t = translations[isLang || 'en'];
    return (
        <div className="website-development-modern">
            {/* Section 1 */}
            <div className={`hero-section-modern ${isLang == "en" ? "ltr" : "rtl"}`} dir={isLang == "en" ? "ltr" : "rtl"} >
                <div className="content-modern">
                    <h1 className="title-modern">{data.title}</h1>
                    <p className={`description-modern ${isLang == "ar" ? 'text-end' : 'text-start'} `}>{data.dec}</p>
                    <div className={`d-flex  ${isLang == "en" ? ' justify-content-end' : 'justify-content-start'} `}>
                        <button className="request-button-modern"> {t.GetStarted} </button>
                    </div>
                </div>
                <div className="image-container-modern">
                    <img
                        src={data.img}
                        alt="Web Development"
                        width={1000}
                        height={450}
                        className="hero-image-modern"
                        style={{ maxWidth: '100%', height: 'auto' }}
                    />
                </div>
            </div>

            {/* Section 2 */}
            <div className="dark-section-modern_container">
                <div className="dark-section-modern">
                    <h2 className={`dark-title-modern ${isLang == "ar" ? 'text-end' : 'text-start'} `}>{data.title2}</h2>
                    <p className={`dark-description-modern ${isLang == "ar" ? 'text-end' : 'text-start'} `}>{data.dec2}</p>
                </div>
            </div>
        </div>
    );
};

export default ServicesSlider;
